import { Button, Layout, Menu, Space, Spin, Table } from "antd";
import { useState } from "react";

import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { showNotificationWithIcon } from "../../utils/helpers/helpers";
import { getList } from "../../utils/http/dataProvider";
import { getMany } from "../../utils/http/dataProvider";
import { getUserInfo } from "../../utils/redux/reducers/User";

import "./ProductSelector.scss";

const i18n = Locale.getInstance();
const { Sider, Content } = Layout;

const ProductSelector = ({
  setSelectedLink,
  selectedLink,
  agentLevelProduct,
}) => {
  const user = useSelector((state) => getUserInfo(state));
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const { data: categoriesData } = useQuery(
    ["product-categories", user.token],
    () =>
      getMany("categories", {
        token: user.token,
        pagination: { perPage: 200, page: 1 },
      }),
    { enabled: !!user.token }
  );

  const categories = categoriesData?.data ?? [];

  const { data, error, isLoading } = useQuery(
    ["products", user.token, agentLevelProduct, page, perPage, selectedCategoryId],
    () =>
      getList("product", {
        pagination: {
          perPage,
          page,
        },
        sort: {
          field: "id",
          order: "desc",
        },
        query: {
          status: 1,
          agentLevelProduct,
          ...(selectedCategoryId != null ? { category_id: selectedCategoryId } : {}),
        },
        token: user.token,
      })
  );

  if (error) {
    showNotificationWithIcon(error.data.message);
  }

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: i18n.t("product.cats.name"),
      render: (item) => {
        return (
          <>
            <Space align="center" direction="vertical">
              <img
                src={`${item?.images[0]?.url}`}
                alt={i18n.getPropNameByLocale(item, "name")}
                width={60}
                height={60}
              />
              <span>{i18n.getPropNameByLocale(item, "name")}</span>
            </Space>
          </>
        );
      },
    },
    {
      title: i18n.t("users.date"),
      dataIndex: "created_at",
      width: 200,
    },
    {
      title: i18n.t("product.cats.actions"),
      width: 100,
      render: (item) => {
        return (
          <>
            <Button
              type={item.id === selectedLink.key ? "primary" : "default"}
              onClick={() => {
                setSelectedLink({
                  key: item.id,
                  image: item.images[0].url,
                  ug_name: `مەھسۇلات ~${item.ug_name}`,
                  zh_name: `产品~${item.zh_name}`,
                  url: `/pages/product-detail/index?productId=${item.id}`,
                });
              }}
              size="small"
            >
              {item.id === selectedLink.key
                ? i18n.t("link.selected")
                : i18n.t("link.select")}
            </Button>
          </>
        );
      },
    },
  ];

  const categoryMenuItems = [
    {
      key: "all",
      label: i18n.t("product.cats.all") || "All",
    },
    ...categories.map((cat) => ({
      key: String(cat.id),
      label: i18n.getPropNameByLocale(cat, "name"),
    })),
  ];

  const onCategorySelect = ({ key }) => {
    setSelectedCategoryId(key === "all" ? null : Number(key));
    setPage(1);
  };

  return (
    <Layout hasSider className="product-selector-layout">
      <Sider
        width={200}
        theme="light"
        className="product-selector-sider"
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedCategoryId == null ? "all" : String(selectedCategoryId)]}
          items={categoryMenuItems}
          onSelect={onCategorySelect}
          style={{ height: "100%", borderRight: 0 }}
        />
      </Sider>
      <Content className="product-selector-content">
        <Spin spinning={isLoading}>
          <div className="products">
            <Table
              className="list"
              rowKey="id"
              columns={columns}
              dataSource={data?.data}
              pagination={{
                current: page,
                total: data?.total,
                pageSize: perPage,
                onChange: (pagination) => {
                  setPage(pagination);
                },
              }}
              scroll={{
                y: 320,
              }}
            />
          </div>
        </Spin>
      </Content>
    </Layout>
  );
};

export default ProductSelector;
